import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable() 
export class BuyerAgreementService {

  constructor(private http: Http, private router: Router) { }

  public verifyWidgetToken(result,docket_id,signerId,time) {
    console.log(result)
  
    // const time =Date.now()
    const data = {
        "widget_token": result,
        "time_stamp": time,
        "docket_id": docket_id,
        "request_id": signerId
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/widgettoken', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
  // verify status
  public verifyStatus(document_id,request_id) {
  
    const buyerId = localStorage.getItem('buyerId');
    const data = {
      "document_id": document_id,
      "request_id" : request_id
  };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/getsignstatus', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
  // get token info
  // verify status
  public getTokenInfo(docket_id,document_id,request_id) {
  
    const buyerId = localStorage.getItem('buyerId');
    const data = {
      "document_id": document_id,
      "docket_id":docket_id,
      "request_id" : request_id
  };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/user/getdocketinfo', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
// get list

public getAgreement() {
  console.log('inside services');
  const buyerId = localStorage.getItem('buyerId');
  return this.http.get(environment.baseUrl + '/user/get_agreements/' + buyerId ,
  GlobalService.getHeaders()).map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 400) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 401) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    }
});
}

}
